/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "Reality.Reality.Api";

/**
 * <strong>path=/api/v2/wise/rate/get</strong>
 * 1USDあたりのLIVEポイントのレートを取得する。
 */
export interface WiseRateGetResponse {
  rateOfUsd: string;
  /** optional:次回のレートが設定されてない場合はnull */
  nextRateOfUsd?:
    | string
    | undefined;
  /** optional:次回のレートが設定されてない場合はnull */
  nextApplicationBeginDate?: Date | undefined;
}

function createBaseWiseRateGetResponse(): WiseRateGetResponse {
  return { rateOfUsd: "", nextRateOfUsd: undefined, nextApplicationBeginDate: undefined };
}

export const WiseRateGetResponse = {
  encode(message: WiseRateGetResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.rateOfUsd !== "") {
      writer.uint32(10).string(message.rateOfUsd);
    }
    if (message.nextRateOfUsd !== undefined) {
      writer.uint32(18).string(message.nextRateOfUsd);
    }
    if (message.nextApplicationBeginDate !== undefined) {
      Timestamp.encode(toTimestamp(message.nextApplicationBeginDate), writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WiseRateGetResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWiseRateGetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.rateOfUsd = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.nextRateOfUsd = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.nextApplicationBeginDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WiseRateGetResponse {
    return {
      rateOfUsd: isSet(object.rateOfUsd) ? globalThis.String(object.rateOfUsd) : "",
      nextRateOfUsd: isSet(object.nextRateOfUsd) ? globalThis.String(object.nextRateOfUsd) : undefined,
      nextApplicationBeginDate: isSet(object.nextApplicationBeginDate)
        ? fromJsonTimestamp(object.nextApplicationBeginDate)
        : undefined,
    };
  },

  toJSON(message: WiseRateGetResponse): unknown {
    const obj: any = {};
    if (message.rateOfUsd !== "") {
      obj.rateOfUsd = message.rateOfUsd;
    }
    if (message.nextRateOfUsd !== undefined) {
      obj.nextRateOfUsd = message.nextRateOfUsd;
    }
    if (message.nextApplicationBeginDate !== undefined) {
      obj.nextApplicationBeginDate = message.nextApplicationBeginDate.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WiseRateGetResponse>, I>>(base?: I): WiseRateGetResponse {
    return WiseRateGetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WiseRateGetResponse>, I>>(object: I): WiseRateGetResponse {
    const message = createBaseWiseRateGetResponse();
    message.rateOfUsd = object.rateOfUsd ?? "";
    message.nextRateOfUsd = object.nextRateOfUsd ?? undefined;
    message.nextApplicationBeginDate = object.nextApplicationBeginDate ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
